import { AuthService } from '@/app/auth/services/auth.service';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, StyleClassModule, AvatarModule, TranslateModule],
    templateUrl: './app.topbar.html'
})
export class AppTopbar {
    private authService = inject(AuthService);
    private router = inject(Router);

    displayName = this.buildDisplayName();
    initials = this.buildInitials();

    private buildDisplayName(): string {
        const first = this.authService.getFirstName();
        const last = this.authService.getLastName();
        const full = [first, last].filter(Boolean).join(' ');
        return full || this.authService.getUsername() || '';
    }

    private buildInitials(): string {
        const first = this.authService.getFirstName();
        const last = this.authService.getLastName();
        if (first && last) {
            return (first.charAt(0) + last.charAt(0)).toUpperCase();
        }
        const username = this.authService.getUsername();
        return username ? username.substring(0, 2).toUpperCase() : '';
    }

    onLogout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }
}
